import React from "react";
import '../index.css';
import "../Styles/homepageStyle.css";
import { Routes, Route } from "react-router-dom";
import Booking from "./Booking";
import Social from "./Social";

const HomepageContent = () => {
  return (
    <div className="container">
      <div className="main"></div>
      <div>
      {/* Arrow Section */}
      <div className="arrow-container">
        <svg
          className="arrow"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      {/* End Arrow Section */}
      </div>
      
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-columns">
            {/* Brand */}
            <div className="footer-col">
              <h3>DJ TLynn</h3>
              <p>Offering professional DJ services for unforgettable events and experiences. International DJ, DJ TLynn, speacializes in genres of Dancehall, Afrobeats, Hip-Hop and more.</p>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <a href="/">Home</a>
              <a href="/social">Social Media</a>
              <a href="/booking">Booking</a>
              <a href="/about">About</a>
            </div>

            {/* Get In Touch */}
            <div className="footer-col">
              <h4>Get In Touch</h4>
              <p>
                <a href="tel:+15126750427" className="footer-phone" style={{color: '#fff', textDecoration: 'underline', transition: 'color 0.2s'}}>+1 (512) 815-3169</a>
              </p>
              <p>
                <span role="img" aria-label="Email"></span> <a href="mailto:bookings@djtlynn.com" className="footer-email" style={{verticalAlign: 'middle'}}>bookings@djtlynn.com</a>
              </p>
              <p>📍 Available Nationwide (Based: Austin Texas)</p>
            </div>
          </div>

          {/* Socials */}
          <div className="social-row">
            <a href="https://www.instagram.com/dj.tlynn/" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
              </svg>
              <span className="social-label">Instagram</span>
            </a>
            <a href="https://www.youtube.com/@DJTlynn" aria-label="YouTube" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <rect x="2" y="4" width="20" height="16" rx="4" ry="4" />
                <polygon points="10 9 16 12 10 15 10 9" fill="currentColor" />
              </svg>
              <span className="social-label">YouTube</span>
            </a>
            <a href="https://www.tiktok.com/@dj.tlynn" aria-label="TikTok" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <path d="M9 17a4 4 0 1 1 0-8v8zm0 0V7.5A4.5 4.5 0 0 1 13.5 3H15v3.5A4.5 4.5 0 0 0 19.5 11H21" />
              </svg>
              <span className="social-label">TikTok</span>
            </a>
          </div>

          <div className="copyright">
            <p>© 2025 DJ TLynn. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

const Homepage = () => {
  return (
    <>
      <Routes>
        <Route path="/Booking" element={<Booking />} />
        <Route path="/Social" element={<Social />} />
        <Route path="/" element={<HomepageContent />} />
      </Routes>
    </>
  );
};

export default Homepage;